module.exports = "<div ng-if=\"$ctrl.item && $ctrl.item.preferred_time && $ctrl.guests\"> <button type=button class=\"button button--wide / c-basket-add\" ng-click=$ctrl.addToBasket() ng-disabled=$ctrl.buttonDisabled()> Add to basket <spinner ng-if=$ctrl.buttonDisabled()></spinner> </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/basket/views/basket.add.html
// module id = 951
// module chunks = 0